/* eslint-disable @angular-eslint/component-selector */
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DisplayLabelPipe, OrderExecTypePipe, OrderIsPartiallyFilledPipe, ShorthandSymbolPipe } from '@zero/shared/ui-pipes';
import { InstrumentDetailsLinkComponent, WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { OrderItemBase } from '../order-item-base/order-item.component';
import { OrderItemExecTypeComponent } from '../order-item-exec-type/order-item-exec-type.component';
import { OrderValueComponent } from '../order-value/order-value.component';
import { StopLimitDataComponent } from '../stop-limit-data/stop-limit-data.component';

@Component({
  selector: 'tr[app-canceled-order-item]',
  templateUrl: './canceled-order-item.component.html',
  imports: [
    InstrumentDetailsLinkComponent,
    WatchlistToggleComponent,
    OrderItemExecTypeComponent,
    StopLimitDataComponent,
    RouterLink,
    DecimalPipe,
    DatePipe,
    TranslocoPipe,
    DisplayLabelPipe,
    OrderIsPartiallyFilledPipe,
    OrderExecTypePipe,
    ShorthandSymbolPipe,
    OrderValueComponent,
  ],
})
export class CanceledOrderItemComponent extends OrderItemBase implements OnChanges {
  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
